export const CREATE_LEAD_REQUEST = 'CREATE_LEAD_REQUEST';
export const CREATE_LEAD_SUCCESS = 'CREATE_LEAD_SUCCESS';
export const CREATE_LEAD_FAILURE = 'CREATE_LEAD_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/create_lead.constants.js